import React from "react";
import BookingDatePicker from "../components/BookingDatePicker";
import TimePicker from "../components/TimePicker";
import BackButton from "../components/BackButton";
import { ReactComponent as ArrowIcon } from "../inlineSvgs/arrow-left.svg";

const SelectDatePage = ({ displayHead }) => {
  return (
    <div className="select-date">
      {displayHead && (
        <div className="mobile-booking-head">
          <BackButton className="back-btn">
            <ArrowIcon />
          </BackButton>
          <div className="title">Select Date & Time</div>
        </div>
      )}
      <BookingDatePicker />
      <TimePicker />
    </div>
  );
};

export default SelectDatePage;
